import React from 'react';
import DWTStyle from './style';
import DSKDWTBG from '../../../images/Home/DSKDWT.png';

export default function DWT() {
	let style = DWTStyle();
	return (
		<div style={style.outerStyle(DSKDWTBG)}>
			<div style={style.contentContainerStyle()}>
				<h1 style={style.titleSyle()}>You want to get in then out, Don’t waste anymore of your time.</h1>
				<p style={style.genericTextStyle()}>
					You are here to work on your goals, not socialize, and get distracted.
				</p>
				<p style={style.genericTextStyle()}>
					You have to take responsibility for every action you make. We can’t always control the outcome of
					our life but we are 100% in control of the effort, and depending on how we carry ourselves, in the
					end, show us it’s much more important than anything else.
				</p>
				<p style={style.genericTextStyle()}>
					I am only able to give you an arsenal of exercises and a plan for you to try and customize but it’s
					all up to you to do the work to reach your goals.
				</p>
			</div>
		</div>
	);
}
